export const filtersVariables = /* GraphQL */ `
  $department: String,
  $sub_categories: [String],
  $brands: [String],
  $brands_quantity: Int,
  $size_types: SizeTypesSearchFilter,
  $price_min: Float,
  $price_max: Float,
  $used: Boolean,
  $shipping_range: String,
  $city: String,
  $state: String,
  $promotion_slug: String,
  $seller_segmentation: String,
  $last_published_at: String,
  $published_before: String,
  $sort: SortSearchInput,
  $exposure: String,
  $plan_id: String,
  $experienced_seller: Boolean,
  $discount_percentage_min: Int,
  $discount_percentage_max: Int,
  $store_kind: String
`
